import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a71d7716"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "checked"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "switch" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "label"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass([(_ctx.disabled || _ctx.readonly) && 'disabled-switch', "container"])
  }, [
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      disabled: _ctx.disabled || _ctx.readonly,
      class: ["input", _ctx.disabled ? 'input-disabled' : ''],
      type: "checkbox",
      checked: _ctx.checked === true || _ctx.checked === 1,
      onChange: _cache[0] || (_cache[0] = (...args) => (_ctx.onChange && _ctx.onChange(...args)))
    }), null, 16, _hoisted_1),
    _hoisted_2,
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.label)), 1))
      : _createCommentVNode("", true)
  ], 2))
}